import { getAgeKey, getPlan, getRiders } from "./rates-format-18-65-gcli.utils";

export const ratesFormat18To65GYRTAndGPA = (ratesOf1865: any[]) => {
    const bandKey = "18-65";

    const result: Record<string, any> = {
        [bandKey]: {
            basic_plan_id: null,
        },
    };
    
    ratesOf1865.forEach((group) => {
        const ageKey = getAgeKey(group.title);

        const plan = getPlan(group.data);
        const riders = getRiders(group.data);

        if (!result[bandKey].basic_plan_id) {
            result[bandKey].basic_plan_id = plan?.plan_id ?? null;
        }

        result[bandKey][ageKey] = [
            {
                basic_rate: plan?.amount || "",
                riders,
            },
        ];
    });

    return result;
}